import { render, staticRenderFns } from "./receiptvoid.vue?vue&type=template&id=99b9e7f8"
import script from "./receiptvoid.vue?vue&type=script&lang=js"
export * from "./receiptvoid.vue?vue&type=script&lang=js"
import style0 from "./receiptvoid.vue?vue&type=style&index=0&id=99b9e7f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports